import apiService from '../services/apiService';

// Utility module for authentication API calls and localStorage management
export const auth = {
  // Performs login API call and stores token/user in localStorage
  login: async (email, password) => {
    try {
      const response = await apiService.post('/auth/login', { email, password });
      if (response.token && response.user && response.user.role) {
        localStorage.setItem('token', response.token);
        response.user.userType = "company";
        localStorage.setItem('user', JSON.stringify(response.user));
        return response.user;
      }
      throw new Error('Invalid response from server: Missing token or user data');
    } catch (error) {
      console.error('Login error:', error);
      throw new Error(error || 'Failed to log in');
    }
  },
  // Performs logout API call and clears localStorage
  logout: async () => {
    try {
      console.log('Attempting logout with token:', localStorage.getItem('token')); // Debug
      const response = await apiService.post('/auth/logout', {}); // Explicitly pass empty object
      console.log('Logout response:', response); // Debug response
    } catch (error) {
      console.error('Logout error details:', error.response?.data || error.message || 'Something went wrong!');
      throw new Error('Failed to log out due to server error');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },
  isAuthenticated: () => !!localStorage.getItem('token'),
  isAdmin: () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role === 'admin' && !!user.role;
  },
  getRole: () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role || null;
  },
  hasRole: (role) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role === role && !!user.role;
  },
};

export default auth;